module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("Distributed by Radius Book Group")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("A Division of Diversion Publishing Corp.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("443 Park Avenue South, Suite 1004")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("New York, NY 10016")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.RadiusBookGroup.com",
      "target": "_blank"
    }
  }, [_vm._v("www.RadiusBookGroup.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Copyright © 2018 by Ben Feder")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or any other information storage and retrieval, without the written permission of the author.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("First edition: April 2018")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Hardcover ISBN: 978-1-63576-367-6")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Trade Paperback ISBN: 978-1-63576-495-6")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("eBook ISBN: 978-1-63576-368-3")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Quote from David Whyte, printed with permission from Many Rivers Press, "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.davidwhyte.com",
      "target": "_blank"
    }
  }, [_vm._v("www.davidwhyte.com")]), _vm._v(". David Whyte, “Fire in the Earth,” "), _c('i', [_vm._v("Fire in the Earth")]), _vm._v(", together with ©Many Rivers Press, Langley, WA USA.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09991411","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rbgfeder0004.vue
// module id = 63
// module chunks = 0